"use client";

import { motion } from "framer-motion";

export const SuccessStories = (props:any)=> {

  return (
    <section className="py-20 bg-gray-50 relative overflow-hidden">
      {/* Section Header */}
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-red-500 font-semibold tracking-wider uppercase">
            {props.subTitle}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">
            {props.title}
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto mt-4">
            {props.description}
          </p>
        </div>

        {/* Case Studies */}
        <div className="grid md:grid-cols-3 gap-10">
          {props.storiesList.map((cs:any, index:number) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              whileHover={{
                scale: 1.04,
                boxShadow: "0 15px 30px rgba(0,0,0,0.12)",
                borderColor: "#ef4444",
              }}
              className="bg-white border border-gray-200 rounded-xl p-8 
                         transition-all duration-300 cursor-pointer"
            >
              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {cs.title}
              </h3>

              {/* Client */}
              <p className="text-sm font-semibold text-red-600 mb-4">
                {cs.client}
              </p>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {cs.description}
              </p>

              {/* Result */}
              <div className="bg-gray-50 p-4 rounded border-l-4 border-red-500">
                <strong className="text-gray-800">Result:</strong>{" "}
                <span className="text-gray-700">{cs.result}</span>
              </div>

        
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
